module.exports = __webpack_public_path__ + "img/image_2.e8dbeaa3.svg";